import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const TopUpPage = lazyWithRetry(() =>
  import("@/features/topUp/pages/TopUpPage").then((m) => ({ default: m.TopUpPage })),
);
const MyTopUpPage = lazyWithRetry(() =>
  import("@/features/topUp/pages/MyTopUpPage").then((m) => ({ default: m.MyTopUpPage })),
);

export const TOP_UP_PATH = "/recharger";
export const MY_TOP_UP_PATH = "/mes-chargements";

const authRoutes: RouteConfig[] = [
  {
    path: TOP_UP_PATH,
    element: <TopUpPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: MY_TOP_UP_PATH,
    element: <MyTopUpPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default authRoutes;
